<template>
  <div class="home" style="background-color: #FFF">
    <MainTopNav :company="company"></MainTopNav>
<!--   H5台湾-->
    <div v-if="isMobile&&isTaiwan" class="taiwan-div">
      <van-grid clickable :border="false" icon-size="100" column-num="1">
        <van-grid-item :icon="require('@/assets/images/taiwan_1.png')" text="汽車材料中心" url="https://goodgood888.com"/>
        <van-grid-item :icon="require('@/assets/images/taiwan_2.png')" text="維修資料查詢" to="/repair/0"/>
        <van-grid-item :icon="require('@/assets/images/taiwan_3.png')" text="保養資料查詢" to="/repair/1"/>
      </van-grid>
    </div>
    <div v-else>
      <van-swipe class="goods-swipe" :autoplay="3000">
        <van-swipe-item v-for="(image, index) in bannerList" :key="index">
          <img class="w-100" :src="global.getStaticFilePath(image)"/>
        </van-swipe-item>
      </van-swipe>
      <van-grid clickable :border="false" icon-size="60">
        <van-grid-item :icon="require('@/assets/images/nav-m-1.png')" text="维修手册" to="/repair/0"/>
        <van-grid-item :icon="require('@/assets/images/nav-m-2.png')" text="正时保养" to="/repair/1"/>
        <!--            <van-grid-item :icon="require('@/assets/images/nav-m-3.png')" text="免费查阅" to="/repair/2" />-->
        <van-grid-item icon="https://cdn2.carziliao.com/wx/images/nav-m-0.png" text="小程序" to="/jumpmp"/>

        <van-grid-item :icon="require('@/assets/images/nav-m-4.png')" text="成为VIP" to="/user/product"/>
      </van-grid>
      <van-notice-bar v-if="news&&news.title" color="#5b5a5a" left-icon="info-o" mode="link" @click="showNews">
        <template #left-icon>
          <van-icon name="volume-o" size="20" color="#ff664d"/>
          <span style="color:#ff664d">公告：</span>
        </template>
        <template class="subtitle-color" #default>{{ news.title }}</template>
      </van-notice-bar>
      <div v-if="hotInfo&&hotInfo.length>0"
           class="index-adv">
        <div class="tip">HOT</div>
        <div class="img-a">
          <a :href="hot.hrefurl?hot.hrefurl:'#'" v-for="(hot,index) in hotInfo" :key="index">
            <div>
              <van-image :src="global.getStaticFilePath(hot.imgurl)"/>
              <div v-if="hot.title">{{ hot.title }}</div>
            </div>
          </a>
          <!-- <div>
            <van-image src="/images/adv-1.gif" />
            <div>广告标题</div>
          </div>
          <div>
            <van-image src="/images/adv-1.gif" />
            <div>广告标题</div>
          </div> -->
        </div>
      </div>
      <div class="ld-list" v-if="company.memberSystemId!=89" clickable :border="false" column-num="2" icon-size="60">
        <!-- <van-grid-item v-for="(video,index) in company.video" :key="index" @click="showVideo(global.getStaticFilePath(video.hrefUrl))">
          <van-image :src="global.getStaticFilePath(video.imgUrl)" />
          <dl class="video-adv p0 p-r">
            <van-icon class="p-a r-0 t-5" size="28" color="#86a9d5" style="position: absolute;" name="video-o" />
            <dt>{{video.title}}</dt>
          </dl>
        </van-grid-item> -->
        <div class="one-ld" @click="showVideo('liangdian','资料亮点')">
          <div class="img">
            <img :src="require('@/assets/images/video-m-1.png')"/>
          </div>
          <div class="ld-title">
            <div class="flex-1">资料亮点</div>
            <van-icon size="28" color="#86a9d5" name="video-o"/>
            <!-- <dd>法拉利型号车百米加速</dd> -->
          </div>
        </div>
        <div class="one-ld" @click="showVideo('liangdian2','查阅问题')">
          <div class="img">
            <img :src="require('@/assets/images/video-m-2.png')"/>
          </div>
          <div class="ld-title">
            <div class="flex-1">查阅问题</div>
            <van-icon size="28" color="#86a9d5" name="video-o"/>
            <!-- <dd>法拉利型号车百米加速</dd> -->
          </div>
        </div>
      </div>
    </div>
    <van-popup v-if="company && company.extendInfo && company.extendInfo.video" v-model="video.isShow"
               @closed="$router.push({ path: '/repair/0' })" closeable position="bottom"
               style="padding-top:50px; background:none;" :style="{ height: '90%' }">
      <VideoModule :video="video"></VideoModule>
    </van-popup>
    <van-image @click="$router.push('/user/product?productType=1')" v-if="false&&company && company.code=='MOREN'"
               :src="require('@/assets/images/index-m-bottom-adv.png')"/>
    <MainMenuNav/>
  </div>
</template>

<script>
import {
  Popup,
  NavBar,
  Image as VanImage,
  Icon,
  Swipe,
  SwipeItem,
  Grid,
  GridItem,
  NoticeBar,
  Tabbar,
  TabbarItem,
  Col,
  Row,
  Dialog,
} from "vant";
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import MainTopNav from "@/components/MainTopNav.vue";
import MainMenuNav from "@/components/MainMenuNav.vue";
import VideoModule from "@/components/Video.vue";
import {
  Get_The_Lastest_News,
  Wx_Bind,
  Check_Wx_Login,
  Refresh_Token,
} from "@/api/index";
import global from "../Global";

export default {
  name: "Home",
  components: {
    HelloWorld,
    MainTopNav,
    MainMenuNav,
    VideoModule,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [VanImage.name]: VanImage,
    [NoticeBar.name]: NoticeBar,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Col.name]: Col,
    [Row.name]: Row,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      active: "home",
      video: {
        path: "",
        isShow: false,
      },
      company: {},
      news: {},
    };
  },
  computed: {
    hotInfo(){
      //志华，写死
      return this.company.memberSystemId==127?
      [
        {
          "hrefurl": "https://ke.qq.com/course/1910381?taid=9727744445064813",
          "imgurl": "companyimage/202110192232473261876.jpg"
        },
        {
          "hrefurl": "https://mp.weixin.qq.com/s/xcHjt0Zl5rSwC-KgO3rOsQ",
          "imgurl": "companyimage/202110192233125581669.jpg"
        },
        {
          "hrefurl": "https://m.ke.qq.com/agencyHome.html?_bid=167&_wv=2147487745&aid=52808#from=wechat",
          "imgurl": "companyimage/202110192233309555534.jpg"
        }
      ]:[]
    },
    bannerList() {
      let list = [];
      if (this.company && this.company.extendInfo && !this.global.isNull(this.company.extendInfo.banner.mobile)) {
        list = this.company.extendInfo.banner.mobile.split(/,/);
      }
      list = list.filter(v => v.trim().length > 0);
      if (list.length == 0) {
        list = ['companyimage/202106160753082375065.jpg'];
      }
      return list;
    },
    isMobile(){
      return this.global.isMobile();
    },

    isTaiwan(){
      return this.company&&this.company.type==1;
    }
  },
  methods: {
    showNews: function () {
      Dialog.alert({
        message: this.news && this.news.title,
      });
    },
    gotoGoods(){
      window.open("https://goodgood888.com")
    },
    showVideo: function (mode, title) {
      // this.video.path = url;
      // this.video.isShow = true;
      this.$router.push({path: 'liangdian', query: {mode: mode, title: title}})
    },
  },
  async mounted() {
    //api接口登陆过来的用户，需要重新获取一下用户信息
    let refreshToken = this.$route.query.RefreshToken;
    if (!this.global.isNull(refreshToken)) {
      this.global.refreshToken(refreshToken);
    }

    // // if ('memberSystemId' in this.$route.query) {
    // await this.global.setMemberSystem(this.$route.query.memberSystemId);
    // // }
    let memberSystemId = this.$route.query.memberSystemId;
    if (!this.global.isNull(memberSystemId)) {
      await this.global.setMemberSystem(memberSystemId);
    }
    this.global.getMemberSystem().then((memberSystem) => {
      if (!this.global.isNull(memberSystem)) {
        this.company = memberSystem;
        if (this.company.type == 1 && !this.isMobile) {
           // this.$router.replace({path: "/repair/0"});
        }
      }
    });

    this.news = {};//await Get_The_Lastest_News() || {};

    //移动端需要绑定微信
    let user = this.global.getUserInfo();
    if (
        this.global.isNull(sessionStorage.getItem("BindFlag")) &&
        !this.global.isNull(user) &&
        this.global.isNull(user.weChat) &&
        !this.global.isNull(user.tel) &&
        user.tel.startsWith("1") &&
        !this.global.isNull(user.memberSystemId) &&
        user.memberSystemId != 78 &&
        user.memberSystemId != 85 &&
        user.memberSystemId != 89
    ) {
      // Check_Wx_Login().then((data) => {
      //   if (data) {
      //     Wx_Bind().then((user) => {
      //       sessionStorage.setItem("BindFlag", "true");
      //       //有错误码的时候，这里是没有返回的
      //       if (!this.global.isNull(user)) {
      //         localStorage.setItem("User", JSON.stringify(user));
      //         localStorage.setItem("AccessToken", user.accessToken);
      //         localStorage.setItem("RefreshToken", user.refreshToken);
      //       }
      //     });
      //   } else {
      //     window.location.href = this.global.APIBasePath + "/User/BindWx";
      //   }
      // });
      if (!this.global.isNull(this.$route.query.refresh)) {
        Refresh_Token({
          refreshToken: localStorage.getItem("RefreshToken"),
        }).then((res) => {
          if (!this.global.isNull(res)) {
            res.memberSystemId = res.systemId
            localStorage.setItem("User", JSON.stringify(res));
            localStorage.setItem("AccessToken", res.accessToken);
            localStorage.setItem("RefreshToken", res.refreshToken);
          }
        });
      }
    }
    debugger
    if(this.isTaiwan){
      this.$router.replace({path: "/pc/choose/0"});
    }
  },
};
</script>
<style lang="scss">

.taiwan-div{
img{
  width:70%;
  height:100px;
}
  .van-grid-item{
    border-bottom: 2px solid #EEE;
  }
  .van-grid-item__text{
    font-size:1.2em;
    font-weight: 600;
    color:blue;
    text-decoration: underline;
    margin-top:-8px;
  }
  .van-grid-item__icon{
    width:100%;
  }
  .van-icon__image{
    object-fit: contain;
  }
}
</style>
<style scoped lang="scss">
.ld-list {
  display: flex;
  align-items: center;
  border-top: 1px solid #EEE;
  background-color: #FFF;

  .one-ld {
    flex: 1;
    padding: 10px;
    display: flex;
    flex-direction: column;
    height: 150px;

    .img {
      //position: relative;
      //display: inline-block;
      img {
        width:100%;
        height: 110px;
      }
    }

    .ld-title {
      height: 30px;
      margin-top: 5px;
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      text-align: left;
      color:#666;
    }
  }
}

</style>
